import Controller, { OnClose } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';

@Controller({ component: 'root-modal', fragment: 'cookie' })
export default class CookieController extends BaseController {

  @OnClose({ target: 'root-modal' })
  onRootModalClose(): void {
    this.historyService.back();
  }

}
